import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=6a4fd70e&scoped=true"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"
import style0 from "./survey.vue?vue&type=style&index=0&id=6a4fd70e&prod&lang=scss"
import style1 from "./survey.vue?vue&type=style&index=1&id=6a4fd70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4fd70e",
  null
  
)

export default component.exports